// src/context/AppContext.js
import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import Global from '../APIConfig';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [companyname, setCompanyname] = useState('Courier X');
  const [companyAddress, setCompanyAddress] = useState('xxxxxx');
  const [phone, setPhone] = useState('9999999999');
  const [email, setEmail] = useState('CourierX@gmail.com');
  const [defaultTimeZone, setDefaultTimeZone] = useState('Asia/Kolkata');
  const [logo, setLogo] = useState('');
  const [printLogo, setPrintLogo] = useState('');
  const [defaultCurrency, setDefaultCurrency] = useState('$');
  const [developeronoff, setDeveloperonoff] = useState('N');
  const [verifiedotp, setVerifiedotp] = useState('N');


  useEffect(() => {
    fetchCompanyName();
  }, []);

  const fetchCompanyName = () => {
    axios.post(Global.baseUrl + 'AllSiteconfigData', {
    })
    .then((res) => {
      if (res.data.status === 200) {
        setCompanyname(res.data.value.company_name);
        setCompanyAddress(res.data.value.company_address);
        setPhone(res.data.value.phone);
        setEmail(res.data.value.email);
        setDefaultTimeZone(res.data.value.default_time_zone);
        setLogo(res.data.value.logo);
        setPrintLogo(res.data.value.print_logo);
        setDefaultCurrency(res.data.value.default_currency);
        setDeveloperonoff(res.data.value.developeronoff);
        setVerifiedotp(res.data.value.verifiedotp);
      }
    })
    .catch((err) => console.error('Failed to fetch company name:', err));
  };

  return (
    <AppContext.Provider value={{ companyname, setCompanyname, 
    companyAddress, setCompanyAddress, 
    phone, setPhone, 
    email, setEmail, 
    defaultTimeZone, setDefaultTimeZone, 
    logo, setLogo, 
    printLogo, setPrintLogo, 
    defaultCurrency, setDefaultCurrency,
    developeronoff, setDeveloperonoff,
    verifiedotp, setVerifiedotp
    }}>
      {children}
    </AppContext.Provider>
  );
};
